import { PanelComercialesState } from './panel_comerciales.types';
import { currentPeriod } from './api';

export const initialPanelComerciales: PanelComercialesState = {
    snapshot: {
        meta: {
            period: currentPeriod(),
            scoringCalculatedAt: null,
            products: [],
            flowTypes: [],
        },
        teams: [],
        commercials: [],
        vips: [],
        notifications: [],
        auditLog: [],
    },
    loading: false,
    saving: false,
    error: null,
    dealsStatus: {
        duplicates: { groups: [], total: 0, limit: 10, offset: 0 },
        duplicatesLoading: false,
        duplicatesSearch: { email: '', owner: '' },
        queue: { items: [], total: 0, limit: 10, offset: 0 },
        queueLoading: false,
        actionLoading: false,
    },
    notifications: { items: [], total: 0, limit: 10, offset: 0 },
    notificationsLoading: false,
    activity: { items: [], total: 0, limit: 10, offset: 0 },
    activityLoading: false,
};
